import React from "react";

import { cn } from "@genuin/ui/lib/utils";
import type { SVGIconsProps } from "../type";
export function PublicIcon({ className, ...restProps }: SVGIconsProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      className={cn("gencl:stroke-black", className)}
      {...restProps}
    >
      <path
        d="M1 10.375C1 12.8614 1.98772 15.246 3.74587 17.0041C5.50403 18.7623 7.8886 19.75 10.375 19.75C12.8614 19.75 15.246 18.7623 17.0041 17.0041C18.7623 15.246 19.75 12.8614 19.75 10.375C19.75 7.8886 18.7623 5.50403 17.0041 3.74587C15.246 1.98772 12.8614 1 10.375 1C7.8886 1 5.50403 1.98772 3.74587 3.74587C1.98772 5.50403 1 7.8886 1 10.375Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.54329 17.7083L5.37663 13.5H6.27663C6.46669 13.5007 6.65434 13.4574 6.82491 13.3735C6.99549 13.2897 7.14438 13.1676 7.25996 13.0167C7.37901 12.8693 7.46147 12.6958 7.50058 12.5104C7.53968 12.325 7.53433 12.1329 7.48496 11.95L6.85996 9.45C6.79446 9.17898 6.63965 8.93789 6.42046 8.76556C6.20127 8.59322 5.93045 8.49968 5.65163 8.5H1.20996"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.8782 4.75H14.4782C14.1994 4.74968 13.9286 4.84322 13.7094 5.01555C13.4902 5.18789 13.3354 5.42898 13.2699 5.7L12.6449 8.2C12.5966 8.38358 12.5926 8.57598 12.6332 8.76141C12.6738 8.94684 12.7577 9.12 12.8782 9.26667C12.9938 9.41755 13.1427 9.53969 13.3132 9.62353C13.4838 9.70737 13.6715 9.75065 13.8615 9.75H15.1782L15.8282 13.7083C15.877 13.9969 16.0254 14.2593 16.2478 14.4496C16.4701 14.64 16.7522 14.7463 17.0449 14.75H18.7115"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
